<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <TableComp
      :data="{
        title: 'Clientes',
        buttons: [{ text: 'Nuevo Cliente', action: openModal }],
        headers: [
          'id',
          'Nombre/Razón Social',
          'Alias',
          'RFC',
          'Calle/#',
          'Colonia/CP',
          'Municipio',
          'Opciones',
        ],
        visibleColumnsMobile: [1, 2, 3, 7],
        ocultar: [0],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <ModalUpdateComp
      v-if="isModalUpdate"
      :title="'Actualizar Cliente'"
      :isOpen="isModalUpdate"
      :selectedData="selectedRow"
      :formFields="formFields"
      @update:selectedData="updateRowData"
      @close="closeModal"
      @updateData="updateClient"
    />

    <TableComp
      :data="{
        title: 'Colaboradores',
        headers: [
          'id',
          'Empresa',
          'Colaborador',
          'Correo',
          'Telefono',
          'Opciones',
        ],
        ocultar: [0],
      }"
      :rows="rowsCollaborators"
      :options="optionsCollaborators"
      @option-click="handleOptionActionCollaborators"
    />

    <ModalUpdateComp
      v-if="isUpdateCollaborators"
      :title="'Actualizar Colaborador'"
      :isOpen="isUpdateCollaborators"
      :selectedData="selectedRow"
      :formFields="formFieldsCollaborators"
      @update:selectedData="updateRowData"
      @updateData="updateCollaborator"
      @close="closeModal"
    />
    <Modal
      v-if="isModalOpen"
      :isOpen="isModalOpen"
      :title="'Nuevo Cliente'"
      :fields="formFields"
      :submitButtonText="'Guardar Cliente'"
      @close="closeModal"
      v-model="formData"
      @submit="dataForm"
    />

    <Modal
      v-if="addCollaborators"
      :isOpen="addCollaborators"
      :title="'Agregar Colaborador'"
      :fields="formFieldsCollaborators"
      :submitButtonText="'Agregar'"
      @close="closeModal"
      v-model="formData"
      @submit="NewCollaborator"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeDelete"
      @confirm="deleteCliente"
    />

    <DeleteComp
      v-if="isDeleteColaboradorOpen"
      :isOpen="isDeleteColaboradorOpen"
      :deleteMessage="deleteMessage"
      @close="closeDelete"
      @confirm="deleteCollaborator"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import Modal from "@/components/ModalComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import ModalUpdateComp from "@/components/ModalUpdateComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    TableComp,
    Modal,
    DeleteComp,
    ModalUpdateComp,
    SpinnerComp,
  },
  data() {
    return {
      isModalOpen: false,
      isDeleteOpen: false,
      isDeleteColaboradorOpen: false,
      addCollaborators: false,
      isModalUpdate: false,
      isUpdateCollaborators: false,
      isSubmitting:false,
      loading: false,
      rows: [],
      formFields: [
        {
          label: "Nombre o Razón Social",
          model: "nombre",
          placeholder: "Nombre o Razón Social",
        },
        {
          label: "Alias o Nombre Corto",
          model: "alias",
          placeholder: "Alias o nombre corto",
        },
        {
          label: "RFC",
          model: "rfc",
          placeholder: "Ingrese RFC",
        },
        {
          label: "Calle y Número",
          model: "calle",
          placeholder: "Ingrese Calle y Número",
        },
        {
          label: "Colonia y CP",
          model: "colonia",
          placeholder: "Ingrese Colonia y CP",
        },
        {
          label: "Municipio",
          model: "municipio",
          placeholder: "Ingrese Municipio",
        },
      ],

      formFieldsCollaborators: [
        {
          label: "Nombre",
          model: "colaborador",
          placeholder: "Ingrese su Nombre",
        },
        {
          label: "Correo",
          model: "correo",
          placeholder: " Ingrese su  Correo",
        },
        {
          label: "Teleono",
          model: "telefono",
          placeholder: " Ingrese su telefono",
        },
      ],
      options: [
        {
          icon: "material-symbols-outlined edit",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
        {
          icon: "material-symbols-outlined person_add",
          action: "add",
          color: "bg-green-500",
        },
      ],
      rowsCollaborators: [],
      optionsCollaborators: [
        {
          icon: "material-symbols-outlined edit",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.addCollaborators = false;
      this.isModalUpdate = false;
      this.isUpdateCollaborators = false;
      this.isDeleteOpen = false;
      this.isDeleteColaboradorOpen = false;
    },
    handleOptionAction(action, row) {
      const actions = {
        edit: () => {
          this.selectedRow = { ...row };
          this.id = row.id;
          this.isModalUpdate = true;
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${row.nombre}?`;
          this.id = row.id;
          this.isDeleteOpen = true;
        },
        add: () => {
          this.idCliente = row.id;
          this.addCollaborators = true;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    handleOptionActionCollaborators(action, rowCollaborators) {
      const actions = {
        edit: () => {
          console.log("Prueba de datos: ", { ...rowCollaborators });
          this.selectedRow = { ...rowCollaborators };
          this.isUpdateCollaborators = true;
          this.idColaborador = rowCollaborators.id;
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${rowCollaborators.colaborador} de la empresa ${rowCollaborators.empresa}?`;
          this.isDeleteColaboradorOpen = true;
          this.idColaborador = rowCollaborators.id;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    getData() {
      this.loading = true;
      this.$axios
        .get("/getCli")
        .then((response) => {
          this.rows = response.data.cliente.map((item) => ({
            id: item.id,
            nombre: item.nombre,
            alias: item.alias,
            rfc: item.rfc,
            calle: item.calle,
            colonia: item.colonia,
            municipio: item.municipio,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dataForm(formData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .post("/registerCli", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    getCollaborators() {
      this.loading = true;
      this.$axios
        .get(`/getCol`)
        .then((response) => {
          if (response.data.estado === "ok") {
            this.rowsCollaborators = response.data.data.map((colaborador) => ({
              id: colaborador.id,
              empresa: colaborador.empresa, // Puedes cambiarlo por el nombre de la empresa si está disponible
              colaborador: colaborador.nombre,
              correo: colaborador.correo || "No especificado",
              telefono: colaborador.telefono || "No especificado",
            }));
          } else {
            alert(response.data.message);
            this.rowsCollaborators = [];
          }
        })
        .catch(() => {
          this.rowsCollaborators = [];
          return;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    NewCollaborator(formData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      const CollaboratorData = {
        idEmpresa: this.idCliente,
        nombre: formData.colaborador,
        telefono: formData.telefono,
        correo: formData.correo,
      };
      this.$axios
        .post("/registerCol", CollaboratorData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
          this.getCollaborators();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    deleteCliente() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .delete(`/deleteCli/${this.id}`)
        .then((response) => {
          this.closeModal();
          alert(response.data.message);
          this.getData();
          this.getCollaborators();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    deleteCollaborator() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .delete(`/deleteCol/${this.idColaborador}`)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
          this.getCollaborators();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    updateClient(updateData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .put(`/updateCli/${this.id}`, updateData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getCollaborators();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    updateCollaborator(updateData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .put(`/updateCol/${this.idColaborador}`, updateData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getCollaborators();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  mounted() {
    this.getData();
    this.getCollaborators();
  },
};
</script>
